var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4005 20.9999H0V7.10742H15V17.4989C15 19.4283 13.3868 20.9999 11.4065 20.9999H11.4005ZM0.902889 20.1203H11.4005C12.8872 20.1203 14.0911 18.9415 14.0911 17.4989V7.98706H0.902889V20.1203Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.0299C6.30818 15.0299 5.33908 14.0857 5.33908 12.9246C5.33908 11.7635 6.30818 10.8193 7.5 10.8193C8.69181 10.8193 9.66091 11.7635 9.66091 12.9246C9.66091 14.0857 8.69181 15.0299 7.5 15.0299ZM7.5 11.699C6.80778 11.699 6.24197 12.2502 6.24197 12.9246C6.24197 13.599 6.80778 14.1502 7.5 14.1502C8.19221 14.1502 8.75802 13.599 8.75802 12.9246C8.75802 12.2502 8.19221 11.699 7.5 11.699Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95144 14.5898H7.04855V17.868H7.95144V14.5898Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29173 7.54733H3.38884V4.00531C3.38884 1.79447 5.23675 0 7.5 0C9.76324 0 11.6112 1.79447 11.6112 4.00531H10.7083C10.7083 2.28121 9.26966 0.879642 7.5 0.879642C5.73033 0.879642 4.29173 2.28121 4.29173 4.00531V7.54733Z",
    fill: "#C72035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.2ea2b32d.svg";
export { ForwardRef as ReactComponent };